import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";

const GetUserButton = withLiteObserverAndTheme(() => {
  const userAdvancedStore = getUserAdvancedStore();

  return (
    <Et3Button
      text="GET"
      type="GET"
      isEnabled={!userAdvancedStore.disableSearchGetButton.get()}
      onClick={async () => await getUserAdvancedStore().getUserData(true)}
      size="MEDIUM"
    />
  );
});

export default GetUserButton;
